/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {LinkAccountEligibilityRequest} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'
import {LinkAccountEligibilityResponse} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'


export const linkAccountEligibility = (request:LinkAccountEligibilityRequest, options?: CashRequestOptions) => post<LinkAccountEligibilityRequest, LinkAccountEligibilityResponse>("/2.0/cash/link-account-eligibility", request, {...options, rejectOnError: true })